var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 1.66667H4.2C3.0799 1.66667 2.51984 1.66667 2.09202 1.88465C1.71569 2.0764 1.40973 2.38236 1.21799 2.75869C1 3.18651 1 3.74656 1 4.86667V9.8C1 10.9201 1 11.4802 1.21799 11.908C1.40973 12.2843 1.71569 12.5903 2.09202 12.782C2.51984 13 3.07989 13 4.2 13H9.13333C10.2534 13 10.8135 13 11.2413 12.782C11.6176 12.5903 11.9236 12.2843 12.1153 11.908C12.3333 11.4802 12.3333 10.9201 12.3333 9.8V7.66667M7.66667 10.3333H3.66667M9 7.66667H3.66667M12.4142 1.58579C13.1953 2.36683 13.1953 3.63317 12.4142 4.41421C11.6332 5.19526 10.3668 5.19526 9.58579 4.41421C8.80474 3.63317 8.80474 2.36683 9.58579 1.58579C10.3668 0.804738 11.6332 0.804738 12.4142 1.58579Z",
    stroke: "#FF9900",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.56344af4d15398bd7e06aab3aaae0ed8.svg";
export { ForwardRef as ReactComponent };